import { render, staticRenderFns } from "./PhotoGalleryCard.vue?vue&type=template&id=3ceffdb8&"
import script from "./PhotoGalleryCard.vue?vue&type=script&lang=js&"
export * from "./PhotoGalleryCard.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGalleryCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports